<div>
  @if (contentEdit && item) {
    <coin-v2-checkbox
      class="spacing-elements"
      [label]="'cms.emails.full-width' | translate"
      [(ngModel)]="item.fullWidth"></coin-v2-checkbox>
    @if (showBackgroundPicker) {
      <div class="spacing-elements">
        <coin-color-picker [(ngModel)]="item.backgroundColor"></coin-color-picker>
      </div>
    }
    <coin-email-slider
      label="Space-Top"
      [(ngModel)]="item.paddingTop"></coin-email-slider>
    <coin-email-slider
      label="Space-Bottom"
      [(ngModel)]="item.paddingBottom"></coin-email-slider>
  }

  @if (item) {
    <div class="email-btn-container">
      @if (contentEdit) {
        <coin-v2-text-input
          [label]="'cms.button-text' | translate"
          [(ngModel)]="item.content.text" />
      }
      @if (contentEdit) {
        <coin-v2-text-input
          [label]="'cms.button-link-url' | translate"
          [placeholder]="'cms.button-link-url-placeholder' | translate"
          [(ngModel)]="item.content.link" />
      }
      @if (!contentEdit) {
        <a
          class="email-btn-link"
          [href]="item.content.link"
          [ngClass]="{ 'btn-full-width': item.fullWidth }">
          {{ item.content.text }}
          <span>&#9002;</span>
        </a>
      }
    </div>
  }
</div>
